import React from "react";
import "./Personalization.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import _nav from "../../../../../_nav";
import { Link } from "react-router-dom";

const Personalization = () => {
  return (
    <section className="Personalization">
      <div className="row justify-content-center">
        <div className="col-lg-12 col-md-10">
          <div className="top_small_banner">
            <img
              src="/assets/images/profile/settings/banners/personalization_banner.png"
              className="banner_img"
            />
          </div>
        </div>
        <div className="col-lg-12 col-md-10">
          <div className="routing_main_div">
            {_nav?.map((item, idx) => {
              return (
                <Link to={item.to} key={idx} className="route_div">
                  <div className="left_side_div">
                    <p className="route_text">{item.name}</p>
                  </div>
                  <div className="rigth_arrow_div">
                    <FontAwesomeIcon
                      icon={faAngleRight}
                      className="icon_class"
                    />
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Personalization;
